<div id="gallery">
    <div class="container">
        <div id="gallery-title" class="text-center">
            <h2>OUR GALLERY</h2>
            <hr class="pb-2 mx-auto rounded opacity-100">
        </div>
        <div class="row" *ngIf="showList">
            <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-4" *ngFor="let image of filterImage;let i = index">
                <div class="card" id="{{image.$key}}" (click)="openGalleryList(image.$key,image.caption)">
                    <img class="card-img-top" [src]="image.imgUrl" alt="Card image cap">

                    <div class="overlay card-body">
                        <p>{{image.caption}}</p>
                    </div>
                </div>

            </div>
        </div>

        <!-- <div *ngIf="!showList">
          <router-outlet></router-outlet>
      </div> -->


    </div>
</div>